import localhost from "apis/localhost";
import { elements } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import {
  setContentData,
  setDataPrevLength,
  setLoading,
} from "slices/dictionarySearch/dictionarySearchSlice";

export const getContent =
  ({ folderId, by, selectedDocuments, selectedTerms }) =>
  async (dispatch) => {
    dispatch(setLoading({ element: elements.CONTENT, loading: true }));
    dispatch(setDataPrevLength());

    const docList = selectedDocuments.map(({ name: docName }) => ({
      docName,
      selectedTerms,
    }));

    try {
      const rsp = await localhost.post(
        `/dictionarySearch/${by}/termInstances`,
        {
          docSetId: folderId,
          docList,
        }
      );
      const data = rsp?.data;
      dispatch(setContentData(data));
      return data;
    } catch (error) {
      dispatch(showErrorModal(error));
      return false;
    } finally {
      dispatch(setLoading({ element: elements.CONTENT, loading: false }));
    }
  };
